'use client';

import { c as _c } from "react/compiler-runtime";
import { AccordionContent, AccordionItem, AccordionTrigger } from '@achra/ui/accordion';
import { cn } from '@achra/ui/lib/utils';
import { pascalCaseToNormalString } from '../../lib/strings';
import type { CategoryTree } from '../../types';
interface CategoryItemProps {
  category: CategoryTree;
}
function flattenDescendants(category: CategoryTree): CategoryTree[] {
  return category.children.flatMap(child => [child, ...flattenDescendants(child)]);
}
function CategoryItem(t0) {
  const $ = _c(11);
  const {
    category
  } = t0;
  const hasChildren = category.children.length > 0;
  let t1;
  if ($[0] !== category || $[1] !== hasChildren) {
    const flattened = flattenDescendants(category);
    const t2 = category.id;
    const t3 = !hasChildren;
    let t4;
    if ($[3] !== hasChildren || $[4] !== t3) {
      t4 = cn("py-2 text-base/6 font-medium capitalize hover:no-underline", {
        "[&>svg]:hidden": t3,
        "cursor-pointer": hasChildren
      });
      $[3] = hasChildren;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== category.name) {
      t5 = pascalCaseToNormalString(category.name);
      $[6] = category.name;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
      t6 = <AccordionTrigger className={t4}>{t5}</AccordionTrigger>;
      $[8] = t4;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t1 = <AccordionItem value={t2} className="border-0">{t6}{hasChildren && <AccordionContent><ul className="space-y-1 pl-4">{flattened.map(_temp)}</ul></AccordionContent>}</AccordionItem>;
    $[0] = category;
    $[1] = hasChildren;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(node) {
  return <li key={node.id} className="text-foreground/50 text-base/6 capitalize">{pascalCaseToNormalString(node.name)}</li>;
}
export { CategoryItem };